import React from 'react';
import Layout from '../../components/common/pageLayout';
import Form from '../../components/Schedule/Form';
import constant from '../../constant';
import { toast } from 'react-toastify';
import { v3_add_schedule_event } from '../../actions/v3/schedule';

const AddCategory = (props) => {
    const onSubmit = (model) => {
        v3_add_schedule_event(model).then((res) => {
            if (res.status) {
                toast.success(res.result.message);
                props.history.push(constant.Authedcomponent.schedulePreview.url);
            } else {
                toast.error(res.error);
            }
        });
    };

    return (
        <React.Fragment>
            <Layout title="Add Schedule">
                <Form
                    title="Add Schedule"
                    onSubmit={onSubmit}
                    buttonName="Create Schedule"
                />
            </Layout>
        </React.Fragment>
    );
};

export default AddCategory;
